import Http from "../util/httpUtils"

export default {
  list: function() {
    return Http.get("/data/car.json")
  },
}
